/* Nude Project Theme — Predictive Search JavaScript */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    var searchInput = document.querySelector('[data-search-input]');
    var resultsContainer = document.querySelector('[data-search-results]');
    if (!searchInput || !resultsContainer) return;

    var debounceTimer;

    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var query = searchInput.value.trim();

      if (query.length < 2) {
        resultsContainer.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function() {
        fetchResults(query);
      }, 300);
    });

    function fetchResults(query) {
      resultsContainer.innerHTML = '<div class="search-loading"><div class="skeleton skeleton--text" style="width:60%"></div><div class="skeleton skeleton--text" style="width:40%"></div></div>';

      var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,page&resources[limit]=5';

      fetch(url)
        .then(function(res) { return res.json(); })
        .then(function(data) {
          renderResults(data, query);
        })
        .catch(function() {
          resultsContainer.innerHTML = '<p class="search-no-results">Search unavailable</p>';
        });
    }

    function renderResults(data, query) {
      var html = '';
      var resources = data.resources && data.resources.results;
      if (!resources) { resultsContainer.innerHTML = ''; return; }

      // Products
      if (resources.products && resources.products.length > 0) {
        html += '<div class="search-results__section">';
        html += '<h4 class="search-results__heading">Products</h4>';
        resources.products.forEach(function(product) {
          var title = highlightMatch(product.title, query);
          var imgSrc = product.image ? product.image.replace(/(\.[^.]+)$/, '_100x$1') : '';
          html += '<a href="' + product.url + '" class="search-results__item">';
          if (imgSrc) html += '<img src="' + imgSrc + '" alt="" class="search-results__img" width="48" height="48">';
          html += '<div class="search-results__info">';
          html += '<span class="search-results__title">' + title + '</span>';
          html += '<span class="search-results__price">' + product.price + '</span>';
          html += '</div>';
          html += '</a>';
        });
        html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="search-results__view-all">View all products →</a>';
        html += '</div>';
      }

      // Collections
      if (resources.collections && resources.collections.length > 0) {
        html += '<div class="search-results__section">';
        html += '<h4 class="search-results__heading">Collections</h4>';
        resources.collections.forEach(function(col) {
          html += '<a href="' + col.url + '" class="search-results__link">' + highlightMatch(col.title, query) + '</a>';
        });
        html += '</div>';
      }

      // Pages
      if (resources.pages && resources.pages.length > 0) {
        html += '<div class="search-results__section">';
        html += '<h4 class="search-results__heading">Pages</h4>';
        resources.pages.forEach(function(page) {
          html += '<a href="' + page.url + '" class="search-results__link">' + highlightMatch(page.title, query) + '</a>';
        });
        html += '</div>';
      }

      if (!html) {
        html = '<p class="search-no-results">No results for "' + query + '"</p>';
      }

      resultsContainer.innerHTML = html;
    }

    function highlightMatch(text, query) {
      var regex = new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
      return text.replace(regex, '<mark>$1</mark>');
    }

    // Keyboard: Escape closes
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        searchInput.value = '';
        resultsContainer.innerHTML = '';
        var overlay = document.querySelector('[data-search-overlay]');
        if (overlay) overlay.classList.remove('is-active');
      }
    });
  });
})();
